import { db } from '@/firebase/init';
import { collection, orderBy, query } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';
import { InvitationFromStore } from '@/types/types';
import { getWorkspaceInvitationsPath } from '@/utils/queryPaths';

function useWorkspaceInvitations(
  workspaceId: string,
): InvitationFromStore<'workspace'>[] {
  const invitationsQuery = useMemo(
    () =>
      query(
        collection(db, getWorkspaceInvitationsPath(workspaceId)),
        orderBy('invitedUserEmail', 'asc'),
      ),
    [workspaceId],
  );

  const invitations = useFirestoreCollection<InvitationFromStore<'workspace'>>(
    ['workspaceInvitations', workspaceId],
    invitationsQuery,
  );

  return invitations;
}

export { useWorkspaceInvitations };
